import { LineChart } from '@/components'
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import typeImageMixin from '@/mixins/type-image-mixin.js' // 引入mixin文件
import {getUserList} from '@/api/get-data.js'
import {VideoPlayerManager} from '@/utils/video-player-manager'

export default {
  name: 'ShowAlarmEvent',
  data () {
    return {
      playProtocol: this.$globalConfig.playProtocol, // 播放协议，0-rtmp,1-hls,2-http-flv,3-ws-flv
      playerManager: null,
      player: null,
      // 遮罩层
      loading: false,
      // 联动控制--------------------------------------------------------------------------------------------------
      controlNodeTableData: [],
      controlNodeTableTotalRow: 0,
      controlNodeTableQueryParams: {
        dataNodeId: 0,
        pageNum: 1,
        pageSize: 3
      },
      // 事件表格当前行
      controlNodeTableCurrentRow: null,
      // 联动抓拍--------------------------------------------------------------------------------------------------
      pictureUrls: [],
      picturePageNum: 1,
      picturePageSize: 1,
      // 联动视频--------------------------------------------------------------------------------------------------
      streamNodes: [],
      streamNodeCenterRecordBeginDateTimes: [],
      streamNodeTableQueryParams: {
        dataNodeId: 0,
        pageNum: 1,
        pageSize: 10
      },
      streamNodePageNum: 1,
      streamNodePageSize: 1
    }
  },
  props: {
    modalOpen: {
      type: Boolean,
      default: false
    },
    alarmEvent: {
      type: Object,
      default: {}
    }
  },
  components: {
    LineChart
  },
  mixins: [
    convertorMixin,
    idNameMixin,
    typeImageMixin
  ],
  created() {
    // 创建播放器管理器
    this.playerManager = new VideoPlayerManager()
    this.player = this.playerManager.findFirstInactiveVideoPlayer()

    // 获取用户列表
    getUserList(() => {
      // 联动控制--------------------------------------------------------------------------------------------------
      // if (this.alarmEvent.resourceKind === 22 || this.alarmEvent.resourceKind === 23) { // 当前只支持数据节点
      //   // 查询控制节点列表
      //   this.getControlNodeListForDataNode().then(res => {
      //     // 查询视频节点列表
      //     this.getStreamNodeListForDataNode()
      //   })
      // }
      // 联动抓拍--------------------------------------------------------------------------------------------------
      // 填充图片url数组
      for (let i = 0; i < this.alarmEvent.pictureCount; ++i) {
        this.pictureUrls.push(this.alarmEvent['pictureUrl' + (i + 1).toString()])
      }
      if (this.alarmEvent.centerCaptureRecordPictureUrl1) {
        this.pictureUrls.push(this.alarmEvent.centerCaptureRecordPictureUrl1)
      }
      if (this.alarmEvent.centerCaptureRecordPictureUrl2) {
        this.pictureUrls.push(this.alarmEvent.centerCaptureRecordPictureUrl2)
      }
      // 联动视频--------------------------------------------------------------------------------------------------
      if (this.alarmEvent.centerRecordStreamNodeId1) {
        this.streamNodeCenterRecordBeginDateTimes.push(this.alarmEvent.centerRecordBeginDateTime1)
      }
      if (this.alarmEvent.centerRecordStreamNodeId2) {
        this.streamNodeCenterRecordBeginDateTimes.push(this.alarmEvent.centerRecordBeginDateTime2)
      }
    })
  },
  mounted () {
  },
  beforeDestroy() {
  },
  methods: {
    // 查询控制节点列表
    getControlNodeListForDataNode() {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.controlNodeTableQueryParams.dataNodeId = this.alarmEvent.resourceId
        this.$http(this.$api.controlNodeListForDataNode, this.controlNodeTableQueryParams).then(
          res => {
            if (res.code === 200) {
              this.controlNodeTableData = res.data
              this.controlNodeTableTotalRow = res.page.totalRow
            }
            this.loading = false
            resolve(res)
          }
        ).catch(err => {
          console.log(err)
          this.loading = false
          reject(err)
        })
      })
    },
    // 查询视频节点列表
    getStreamNodeListForDataNode() {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.streamNodeTableQueryParams.dataNodeId = this.alarmEvent.resourceId
        this.$http(this.$api.streamNodeListForDataNode, this.streamNodeTableQueryParams).then(
          res => {
            if (res.code === 200) {
              this.streamNodes = res.data
            }
            this.loading = false
            resolve(res)
          }
        ).catch(err => {
          console.log(err)
          this.loading = false
          reject(err)
        })
      })
    },
    //
    getCurrentStreamNodeRecordTitle() {
      let recordInfo = '联动录像'
      if (this.streamNodes.length === 0 || this.streamNodePageNum > this.streamNodes.length) {
        return recordInfo
      }

      recordInfo += '-'
      recordInfo += this.streamNodes[this.streamNodePageNum - 1].name
      recordInfo += '-'
      if (this.streamNodePageNum <= this.streamNodeCenterRecordBeginDateTimes.length) {
        recordInfo += this.strDateTimeFromMsTime_t(this.streamNodeCenterRecordBeginDateTimes[this.streamNodePageNum - 1])
      } else {
        recordInfo += '无录像'
      }
      return recordInfo
    },
    // 分页
    handleControlNodeTableCurrentPageChange(val) {
      this.controlNodeTableQueryParams.pageNum = val
      this.getControlNodeList()
    },
    // 表格当前记录改变
    handleControlNodeTableCurrentChange(currentRow, oldCurrentRow) {
      if (currentRow == null) {
        return
      }

      this.controlNodeTableCurrentRow = currentRow
    },
    //
    handleControlNodeOpen (row) {
      let queryText = '您确定打开【' + row.name + '】吗?'
      this.$messagebox.confirm(queryText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let controlParams = {
          nodeId: row.id,
          controlCmd: 1
        }
        this.$http(this.$api.doControl, controlParams).then(
          res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            } else {
              this.$message({
                type: 'error',
                message: '操作失败!'
              })
            }
          }
        )
      })
    },
    //
    handleControlNodeClose (row) {
      let queryText = '您确定关闭【' + row.name + '】吗?'
      this.$messagebox.confirm(queryText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let controlParams = {
          nodeId: row.id,
          controlCmd: 0
        }
        this.$http(this.$api.doControl, controlParams).then(
          res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            } else {
              this.$message({
                type: 'error',
                message: '操作失败!'
              })
            }
          }
        )
      })
    },
    // 分页
    handlePictureCurrentPageChange(val) {
      this.picturePageNum = val
    },
    // 分页
    handleStreamNodeCurrentPageChange(val) {
      this.streamNodePageNum = val
    },
    //
    handleToggleVideo () {
      if (this.streamNodes.length <= 0) {
        return
      }

      if (!this.player.active) {
        let queryText = '您确定打开【' + this.streamNodes[this.streamNodePageNum - 1].name + '】视频吗?'
        this.$messagebox.confirm(queryText, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.playerManager.openVideoPlayer(this.streamNodes[this.streamNodePageNum - 1].id, this.streamNodes[this.streamNodePageNum - 1].name,
            this.streamNodes[this.streamNodePageNum - 1].streamOpenMode, false, this.$store.getters.userToken, this.playProtocol, '', 0)
        })
      } else {
        this.playerManager.closeVideoPlayer(this.streamNodes[this.streamNodePageNum - 1].id)
      }
    },
    //
    handlePrintTrue() {
      this.$refs.handleIdeaTextArea.value = '真实告警'
    },
    //
    handlePrintFalse() {
      this.$refs.handleIdeaTextArea.value = '误报'
    },
    //
    handleClearHandleIdea() {
      this.$refs.handleIdeaTextArea.value = ''
    },
    //
    handleConfirmAlarm() {
      this.$confirm('您确定提交告警处理结果吗?', '询问', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http(this.$api.confirmAlarm, {
          eventId: this.alarmEvent.id,
          handleIdea: this.$refs.handleIdeaTextArea.value
        }).then(res => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '提交成功!'
            })
            this.$emit('submit', false)
          } else {
            this.$message({
              type: 'error',
              message: '提交失败!'
            })
          }
        })
      })
    },
    // 取消提交记录
    handleModalCancel () {
      this.$emit('cancel', false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/common/showAlarmEvent/ShowAlarmEvent.js